import React, { ReactNode } from "react";
import Sidebar from "../navigation/Sidebar";
import TopHeader from "../ui/TopHeader";
import { ToastContainer } from "react-toastify";

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  return (
    <div className="flex h-screen overflow-hidden bg-[#f0f1f3]">
      <Sidebar />
      <div className="flex min-h-0 min-w-0 flex-1 flex-col">
        <TopHeader />
        <div className="min-h-0 flex-1">
          {children}
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default Layout;
